import { render } from "./DocumentDownload.vue?vue&type=template&id=64c8def0&scoped=true"
import script from "./DocumentDownload.vue?vue&type=script&lang=js"
export * from "./DocumentDownload.vue?vue&type=script&lang=js"

import "./DocumentDownload.vue?vue&type=style&index=0&id=64c8def0&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\JCXS\\CAAMSNG\\frontend-caams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64c8def0"]])

export default __exports__